import { useEffect } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import HeroSection from './components/HeroSection';
import CategoryNav from './components/CategoryNav';
import FeaturedArticles from './components/FeaturedArticles';
import LatestArticles from './components/LatestArticles';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';

export default function Home() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <CategoryNav />
        <FeaturedArticles />
        <LatestArticles />
        <FAQSection />
        <CTASection />
      </main>
      <Footer />
      <ScrollToTop />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebSite',
            name: 'P站视频全攻略',
            url: 'https://pstation-guide.readdy.ai/',
            description: 'P站视频的搜索技巧、分类浏览、高清下载与收藏管理全流程攻略，适合新手与进阶用户参考。',
            potentialAction: {
              '@type': 'SearchAction',
              target: 'https://pstation-guide.readdy.ai/search?q={search_term_string}',
              'query-input': 'required name=search_term_string',
            },
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'Organization',
            name: 'P站视频全攻略',
            url: 'https://pstation-guide.readdy.ai/',
            description: '致力于提供最全面、最实用的P站视频使用教程。',
          }),
        }}
      />
    </>
  );
}